var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"molecule-availability-filter-results"},[(_vm.isLoadingData)?_c('div',{staticClass:"loader-container"},[_c('AtomsAtomLoader',{attrs:{"size":{ width: 7, height: 7 },"thickness":0.45}})],1):_c('Fragment',[_c('MoleculesProjectBuildingV2MoleculeAvailabilityFilterResultsList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }